export const resolveProposalName = (
    mode: 'dir' | 'lead',
    proposalName: string,
    leadName: string,
    fallback: string,
) => (mode === 'lead' ? String(proposalName || leadName || fallback) : proposalName);
